module.exports = __webpack_public_path__ + "static/media/Hero2.6439ae44.jpg";